// model based on API::V1::Activity::V1::IntentionSetterSerializer
export default {
// --- Specific for single activity embed  ---
  // Relationships
  global_slide: {
    jsonApi: 'hasOne',
    type: 'global_slide'
  },

  resources: {
    jsonApi: 'hasMany',
    type: 'resource_cards'
  },

  // Attributes
  overlay: null,
  // ------------------------------------------

  // Images
  background_image: null,
  result_image: null,
  gradient_start: null,
  gradient_end: null,

  // Attributes
  label: null,
  headline: null,
  subheadline: null,
  intentions: [],
  goal_dates: [],
  early_close_trigger: null,
  configuration: {},
  intention_step: {},
  goal_date_step: {}
}
